<template>
  <div
    :class="rootClasses"
    ref="effectItem"
    v-click-outside="hidePreview"
  >
    <button
      class="dd-effect__toggle"
      type="button"
      :disabled="disabled"
      @click="select"
    >
      <span class="dd-effect__radio" aria-hidden="true">
        <span class="dd-effect__radio-dot"></span>
      </span>
      <div class="dd-effect__body">
        <div class="dd-effect__tags">
          <span v-if="badgeLabel" class="dd-effect__badge">{{ badgeLabel }}</span>
          <span v-if="annotation" class="dd-effect__tag">{{ annotation }}</span>
        </div>
        <h4 class="dd-effect__name">{{ effect.name }}</h4>
        <p v-if="description" class="dd-effect__description">{{ description }}</p>
      </div>
      <div class="dd-effect__meta">
        <button
          v-if="hasPreview"
          type="button"
          class="dd-effect__preview-btn"
          @click.stop="togglePreview"
        >
          {{ $t('wall.effects.effects.preview') }}
        </button>
      </div>
    </button>
    <transition name="dd-effects-fade">
      <div v-if="preview" class="dd-effect__preview" :class="{ 'dd-effect__preview--top': bottom }">
        <div class="dd-effect__preview-card">
          <div class="dd-effect__preview-head">
            <h5 class="dd-effect__preview-title">{{ effect.name }}</h5>
            <button class="dd-effect__preview-close" type="button" @click="hidePreview" :aria-label="$t('wall.effects.effects.close_preview')">
              &times;
            </button>
          </div>
          <div class="dd-effect__preview-img">
            <img :src="effect.imgPreview" :alt="effect.name" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import ClickOutside from "vue-click-outside";
export default {
  name: "EffectItem",
  props: {
    effect: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      bottom: false,
    };
  },
  computed: {
    selected() {
      return this.$store.getters.selectedEffect === this.effect.id;
    },
    preview() {
      return this.$store.getters.previewedEffect === this.effect.id;
    },
    disabled() {
      return !this.$store.getters.allowedEffects[this.effect.id];
    },
    annotation() {
      if (this.$store.getters.paidMode) {
        if (!this.effect.minDonation || !this.effect.donationEnabled) {
          return null;
        }
        return this.$t('wall.effects.effects.min_donation', {
          amount: this.effect.minDonation,
          currency: this.$store.getters.currencySymbol,
        });
      }
      const cls = this.$store.getters.effectClasses.find((item) => item.id === this.effect.cls);
      return cls ? cls.name : null;
    },
    badgeLabel() {
      if (this.effect.effectType === 'preset') {
        return this.$t('wall.effects.effects.badge_preset');
      }
      return null;
    },
    description() {
      const text = (this.effect.description || '').trim();
      return text || null;
    },
    hasPreview() {
      return !!this.effect.imgPreview;
    },
    rootClasses() {
      return {
        'dd-effect': true,
        'is-active': this.selected,
        'is-disabled': this.disabled,
        'is-bottom': this.bottom,
      };
    },
  },
  watch: {
    preview(newVal) {
      if (newVal) {
        this.bottom = this.shouldOpenUpwards();
      }
    },
  },
  methods: {
    togglePreview() {
      if (this.preview) {
        this.hidePreview();
      } else {
        this.showPreview();
      }
    },
    showPreview() {
      if (!this.hasPreview) {
        return;
      }
      this.bottom = this.shouldOpenUpwards();
      this.$store.dispatch('previewEffect', this.effect.id);
    },
    hidePreview() {
      this.$store.dispatch('previewEffect', null);
    },
    select() {
      if (this.disabled) {
        return;
      }
      this.$store.dispatch('selectEffect', this.effect.id);
    },
    shouldOpenUpwards() {
      if (!this.$refs.effectItem) {
        return false;
      }
      const rect = this.$refs.effectItem.getBoundingClientRect();
      return rect.top + 360 > window.innerHeight;
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>
